module.exports = __webpack_public_path__ + "static/img/dbid-truck-land.a2b306ca.jpg";